import { defineMessages } from '@transcend-io/internationalization';

export const contactSupportBannerMessages = defineMessages(
  'privacy-center.components.ContactSupportBanner.contactSupportBanner',
  {
    header: {
      defaultMessage: 'Questions?',
    },
    descriptionA: {
      defaultMessage: "Don't miss your options in the {takeControl} panel.",
    },
    descriptionB: {
      defaultMessage: 'Something else? Let us know.',
    },
  },
);
